
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import FormBuilder from '../../components/common/form-builder.vue'
    import excom from '../../components/excom.vue'
    const partner = namespace('partner')

    @Component({
        components: {
            FormBuilder,
            excom
        }
    })
    export default class Home extends Vue{
        form:any = {
            name: '',
            phone:'',
            excom:'',
            price:'0.3',
            desc:'',
            excooperation: false,
            eorderId: '',
            eorderKey: ''
        }
        id:string = '' //如果是编辑进来的id
        get formOptions(){
            const res = [{
                label: '快递员姓名',
                prop: 'name',
                type: 'input',
                ruleType: 'text'
            },{
                label: '快递员电话',
                prop: 'phone',
                type: 'input',
                ruleType: 'text'
            },{
                label: '快递公司',
                prop: 'excom',
                type: 'slot',
                ruleType: 'text'
            },
            {
                label: '快递单价',
                prop: 'price',
                type: 'InputNumber',
                min: 0.1,
                step: 0.1,
                ruleType: 'text'
            },
            {
                label: '合作寄件',
                prop: 'excooperation',
                type: 'slot',
                ruleType: 'text'
            },
//            {
//                label: '电子面单账号',
//                prop: 'eorderId',
//                type: 'input',
//                ruleType: 'text'
//            },
//            {
//                label: '电子面单密钥',
//                prop: 'eorderKey',
//                type: 'input',
//                ruleType: 'text'
//            },
            {
                label: '备注',
                prop: 'desc',
                type: 'textarea',
                row: 2
            }];
            if(this.form.excooperation){
                    res.splice(5,0, {
                    label: '寄件地址',
                    prop: 'eorderAddress',
                    type: 'slot',
                });
            }
            return res;
        }
        @partner.State("partnerDetail") partnerDetail:any
        @partner.Action("addPartner") addPartner:any
        @partner.Action("modifyPartner") modifyPartner:any
        @partner.Action("getPartnerDetail") getPartnerDetail:any

        get edit(){
            const id = this.$route.query.id;
            this.id = id;
            if(id){
                return true
            }
            return false
        }
        async created(){
			if(this.edit){
                await this.getPartnerDetail(this.id)
                this.form = {
                    name: this.partnerDetail.name,
                    phone:this.partnerDetail.phone,
                    excom:this.partnerDetail.excom,
                    price:this.partnerDetail.price,
                    desc:this.partnerDetail.desc,
                    excooperation: this.partnerDetail.excooperation,
                    eorderId: this.partnerDetail.eorderId,
                    eorderKey: this.partnerDetail.eorderKey,
                    eorderAddress: this.partnerDetail.eorderAddress,
                }
			}
		}
        async add(){
            const res = await this.$refs.builder.submitForm()
            console.log(res);
            if(res){
                 const res = await this.addPartner(this.form)
                 if(res){
                    this.$message({  message: '创建成功',type: 'success' });
                    this.rest()
                 }
            }
            
        }
        async modify(){
            const res = await this.$refs.builder.submitForm()
            if(res){
                 const res = await this.modifyPartner({id: this.id, data:this.form})
                 if(res){
                    this.$message({  message: '修改成功',type: 'success' });
                    this.$router.go(-1)
                 }
            }
        }
        rest(){
            this.$refs.builder.resetForm()
        }
    }
